module.exports = __webpack_public_path__ + "img/icon_delete.8aa55d9.png";